<div class="lum-c-job-status-details-popup">
  <div class="lum-c-job-status-details-popup__header">
    <h5 class="lum-c-job-status-details-popup__title">Active Jobs</h5>
    <button 
      type="button" 
      class="lum-c-job-status-details-popup__close-btn"
      mat-icon-button
      (click)="closeDialog()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Filter Controls -->
  <div class="lum-c-job-status-details-popup__filters">
    <div class="lum-c-job-status-details-popup__filter-row">
      <mat-form-field appearance="outline" class="lum-c-job-status-details-popup__filter-field">
        <mat-label>Job Type</mat-label>
        <mat-select [formControl]="jobTypeControl">
          <mat-option value="">All Job Types</mat-option>
          <mat-option 
            *ngFor="let jobType of jobTypes$ | async" 
            [value]="jobType"
            [title]="jobType"
          >
            <span class="lum-c-job-status-details-popup__job-type-option">
              {{ formatJobTypeName(jobType) }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="lum-c-job-status-details-popup__filter-field">
        <mat-label>Status</mat-label>
        <mat-select [formControl]="statusControl">
          <mat-option value="">All Statuses</mat-option>
          <mat-option 
            *ngFor="let status of statuses$ | async" 
            [value]="status"
          >
            {{ status }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="lum-c-job-status-details-popup__filter-field lum-c-job-status-details-popup__search-field">
        <mat-label>Search</mat-label>
        <input matInput [formControl]="searchControl" placeholder="Search jobs...">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <!-- Jobs List -->
  <div class="lum-c-job-status-details-popup__jobs" *ngIf="filteredJobs$ | async as jobs">
    <div class="lum-c-job-status-details-popup__job-row" *ngFor="let job of jobs">
      <div class="lum-c-job-status-details-popup__job-content">
        <!-- Started Time -->
        <div class="lum-c-job-status-details-popup__job-time">
          {{ job.createdAt | date: 'h:mm a' }}
        </div>
        
        <!-- Job Description -->
        <div class="lum-c-job-status-details-popup__job-description">
          <div class="lum-c-job-status-details-popup__job-info">
            <a 
              class="lum-c-job-status-details-popup__job-title" 
              [title]="job.label"
              href="javascript:;"
              (click)="viewJobOutput(job)"
            >
              {{ formatJobTypeName(job.label) }}
            </a>
            <div class="lum-c-job-status-details-popup__job-actions" *ngIf="isImportJob(job)">
              <button
                mat-button
                color="accent"
                class="lum-c-job-status-details-popup__action-btn"
                (click)="redirectToJobStatus(job)"
              >
                <mat-icon>launch</mat-icon>
                Go to Import Page
              </button>
            </div>
          </div>
        </div>
        
        <!-- Status with Progress Bar -->
        <div class="lum-c-job-status-details-popup__job-progress">
          <div *ngIf="!isJobFinished(job)" class="lum-c-job-status-details-popup__progress-container">
            <mat-progress-bar 
              mode="determinate" 
              [value]="job.progress"
              class="lum-c-job-status-details-popup__progress-bar"
            ></mat-progress-bar>
            <span class="lum-c-job-status-details-popup__progress-text">{{ job.progress }}%</span>
          </div>
        </div>
        
        <!-- Status Badge -->
        <div class="lum-c-job-status-details-popup__job-status">
          <span 
            class="lum-c-job-status-details-popup__status-badge"
            [ngClass]="'lum-c-job-status-details-popup__status-badge--' + job.status"
          >
            {{ job.status }}
          </span>
        </div>
      </div>
    </div>
    
    <!-- Empty State -->
    <div *ngIf="jobs.length === 0" class="lum-c-job-status-details-popup__empty-state">
      <mat-icon class="lum-c-job-status-details-popup__empty-icon">work_off</mat-icon>
      <p class="lum-c-job-status-details-popup__empty-text">No jobs found matching the current filters.</p>
    </div>
  </div>

  <!-- Footer -->
  <div class="lum-c-job-status-details-popup__footer">
    <span class="lum-c-job-status-details-popup__refresh-info">
      Last refreshed just now
    </span>
    <button 
      mat-button 
      color="primary"
      class="lum-c-job-status-details-popup__refresh-btn"
      (click)="refreshJobs()"
    >
      <mat-icon>refresh</mat-icon>
      Refresh now
    </button>
  </div>
</div>
